import { render, staticRenderFns } from "./LinhaDeNotasFiscaisEmitidas.vue?vue&type=template&id=845da2ec&scoped=true"
import script from "./LinhaDeNotasFiscaisEmitidas.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeNotasFiscaisEmitidas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeNotasFiscaisEmitidas.vue?vue&type=style&index=0&id=845da2ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845da2ec",
  null
  
)

export default component.exports